import * as React from "react";
import { UitkLayoutFlex } from "uitk-react-layout-flex";
import { QueryRoute } from "bernie-core";
import { GtPWAViewProps } from "../../typings";
import { GroundTransportTypeMenu } from "./GroundTransportTypeMenu";
import { FromAirportView } from "./FromAirportView";
import { ToAirportView } from "./ToAirportView";
import { UitkLayoutGrid, UitkLayoutConditionalGridColumnRow } from "uitk-react-layout-grid";
import { SubmitRow } from "components/shared/StorefrontWizard/SubmitRow/SubmitRow";

export const GroundTransportPWAView: React.FunctionComponent<GtPWAViewProps> = (props) => {
  enum subLOBs {
    from = "fromAirport",
    to = "toAirport",
  }

  const mainGridColumns: UitkLayoutConditionalGridColumnRow = { small: 1, medium: 12, large: 12 };

  return (
    <>
      <UitkLayoutFlex space="six" className="all-b-padding-two">
        <GroundTransportTypeMenu
          setType={props.setType}
          isSubLOBMenuOpen={props.isSubLOBMenuOpen}
          onSubLOBMenuItemClick={props.onSubLOBMenuItemClick}
          onSubLOBMenuTriggerClick={props.onSubLOBMenuTriggerClick}
        />
      </UitkLayoutFlex>

      <UitkLayoutGrid columns={mainGridColumns} space="two" className="all-b-padding-three">
        <QueryRoute query={{ pwaSubLOB: subLOBs.from }}>
          <FromAirportView
            setInputsRefs={props.setInputsRefs}
            carWizardState={props.carWizardState}
            toggleBookRoundtrip={props.toggleBookRoundtrip}
            getLocError={props.getLocError}
          />
        </QueryRoute>
        <QueryRoute query={{ pwaSubLOB: subLOBs.to }}>
          <ToAirportView
            setInputsRefs={props.setInputsRefs}
            carWizardState={props.carWizardState}
            getLocError={props.getLocError}
          />
        </QueryRoute>
      </UitkLayoutGrid>

      <SubmitRow lobState={props.carWizardState} rfrr={"SearchClick_Gt"} />
    </>
  );
};
